var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"documents_alert"},[_c('p',{staticClass:"title"},[_vm._v("Recebemos todos os documentos e estamos analisando!")])])}]

export { render, staticRenderFns }